"use client";

import * as React from "react";
import { BookOpen, Clock, Monitor, Zap, MessageCircle, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const courseModules = [{
  title: "Fundamentos de Electrónica Analógica",
  content: "Estudio profundo de componentes pasivos y activos: resistencias, capacitores, diodos y transistores. Análisis de circuitos en corriente continua y alterna para el diagnóstico preciso de fallas."
}, {
  title: "Electrónica Digital y Microcontroladores",
  content: "Fundamentos de sistemas binarios, compuertas lógicas y arquitectura de microcontroladores. Introducción a la programación de sistemas embebidos y automatización de procesos electrónicos."
}, {
  title: "Fuentes de Alimentación Conmutadas",
  content: "Diseño, diagnóstico y reparación avanzada de fuentes conmutadas (Switching) y lineales. Técnicas de filtrado, regulación de tensión y protección de circuitos integrados sensibles."
}, {
  title: "Laboratorio de Soldadura y Tecnología SMD",
  content: "Práctica intensiva de soldadura profesional, técnicas de desoldadura y manejo de estaciones de aire caliente para el retrabajo de componentes de montaje superficial (SMD)."
}, {
  title: "Diagnóstico y Reparación de Equipos",
  content: "Metodologías avanzadas para la detección de fallas en equipos de audio, video y sistemas electrónicos modernos mediante el uso profesional de osciloscopio y multímetro."
}];
export default function DetallesDelCurso() {
  const course = {
    category: "oficio"
  };
  return <section data-section-id="116040" id="detalles-del-curso" className="relative bg-background py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[hsl(222_47%_11%)]">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:32px_32px]"></div>
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.6)_100%)]"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          
          {}
          <div className="lg:col-span-7 space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-5xl font-sans font-bold text-white tracking-tight">
                Programa Académico
              </h2>
              <p className="text-slate-400 text-lg max-w-2xl font-sans">
                Un recorrido técnico exhaustivo diseñado para formarte como un profesional competente, desde la teoría básica hasta la práctica en entornos reales.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-[12px] rounded-3xl p-6 md:p-8 border border-white/10 shadow-2xl">
              <Accordion type="single" collapsible className="w-full">
                {courseModules.map((module, i) => <AccordionItem key={i} value={`module-${i}`} data-index={i} className="border-white/10">
                    <AccordionTrigger className="text-white hover:text-secondary hover:no-underline py-5 group">
                      <div className="flex items-center gap-4 text-left">
                        <div className="bg-secondary/20 p-2 rounded-lg group-hover:bg-secondary/30 transition-colors shadow-[0_0_15px_rgba(234,179,8,0.2)]">
                          <Zap className="size-5 text-secondary shrink-0" />
                        </div>
                        <span className="font-sans font-bold text-lg md:text-xl tracking-tight">
                          {module.title}
                        </span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="text-slate-300 text-base leading-relaxed pb-6 pl-[3.25rem] md:pl-[3.75rem] font-sans">
                      {module.content}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <Card className="rounded-[24px] border-white/10 shadow-2xl overflow-hidden bg-[hsl(222,47%,15%)] backdrop-blur-md">
              <CardHeader className="bg-white/5 pb-8 pt-8 border-b border-white/10">
                <CardTitle className="text-2xl font-sans font-bold text-white">
                  Ficha del Curso
                </CardTitle>
                <CardDescription className="text-slate-400 text-base font-sans">
                  Detalles técnicos y administrativos para tu inscripción.
                </CardDescription>
              </CardHeader>
              
              <CardContent className="p-8 space-y-8">
                <div className="space-y-6 font-mono text-sm">
                  <div className="flex items-center justify-between border-b border-white/10 pb-4">
                    <div className="flex items-center gap-3 text-slate-400">
                      <Clock className="size-5 text-secondary" />
                      <span>Duración</span>
                    </div>
                    <span className="font-semibold text-white">8 Meses</span>
                  </div>
                  
                  <div className="flex items-center justify-between border-b border-white/10 pb-4">
                    <div className="flex items-center gap-3 text-slate-400">
                      <Monitor className="size-5 text-secondary" />
                      <span>Modalidad</span>
                    </div>
                    <span className="font-semibold text-white">
                      {course.category === "enterprise" ? "Online" : "Presencial"}
                    </span>
                  </div>

                  <div className="flex items-center justify-between border-b border-white/10 pb-4">
                    <div className="flex items-center gap-3 text-slate-400">
                      <BookOpen className="size-5 text-secondary" />
                      <span>Certificación</span>
                    </div>
                    <span className="font-semibold text-white">Profesional</span>
                  </div>
                </div>

                <div className="pt-2">
                  <div className="text-xs font-mono text-slate-500 mb-2 uppercase tracking-widest">
                    Inversión Total
                  </div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-5xl font-bold tracking-tighter text-white">$18.000</span>
                    <span className="text-xl text-secondary font-mono font-medium">
                      $U
                    </span>
                  </div>
                  <p className="text-xs text-slate-500 mt-2 font-mono italic">
                    *Consulta por planes de financiación sin interés.
                  </p>
                </div>
              </CardContent>
              
              <CardFooter className="p-8 pt-0 flex flex-col gap-4">
                <Link to="https://mpago.la/1WfMEZk" className="w-full" newTab>
                  <Button size="lg" className="w-full group text-base font-semibold h-12 bg-[#009EE3] hover:bg-[#008ED2] text-white border-none shadow-md transition-all">
                    Pagar con Mercado Pago
                    <ArrowRight className="size-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </Link>
                <Link to="https://wa.me/59896344395" className="w-full" newTab>
                  <Button size="lg" className="w-full group text-base font-semibold h-12 bg-[#25D366] hover:bg-[#22c35e] text-white border-none shadow-md transition-all">
                    <MessageCircle className="size-5 mr-2" />
                    Consultar por WhatsApp
                  </Button>
                </Link>
              </CardFooter>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}